import { render } from "./TokenBody.vue?vue&type=template&id=78063a9a"
import script from "./TokenBody.vue?vue&type=script&lang=js"
export * from "./TokenBody.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__